// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_Dwb","cls2":"AutoCompleteResults-cls2__70 AutoCompleteResults-cls1_Dwb","show":"AutoCompleteResults-show_Xqw"};